import $ from 'jquery';
import 'bootstrap';

const initFrontendChrome = () => {
    var windowWidth = $(window).outerWidth();

    const mainContent = $('.content-main');
    const header = $('.header');
    const utilHeight = $('.header-utility').outerHeight();

    if (!mainContent.length || !header.length) {
        return;
    }

    mainContent.css('margin-top', header.outerHeight());

    window.addEventListener('scroll', function () {
        const currentScroll = window.pageYOffset;

        if (windowWidth > 992) {
            if (currentScroll > utilHeight) {
                header.css('margin-top', utilHeight * -1);
            }

            if (currentScroll <= utilHeight) {
                header.css('margin-top', currentScroll * -1);
            }
        }
    }, { passive: true });

    window.addEventListener('resize', function () {
        windowWidth = $(window).outerWidth();
        mainContent.css('margin-top', header.outerHeight());
    });

    $('.header .menu-toggle').on('click', function (e) {
        e.preventDefault();
        const toggle = $(this);
        const nav = $('.header .navigation.primary-nav');

        if (toggle.attr('aria-expanded') === 'true') {
            nav.removeClass('active');
            toggle.removeClass('active');
            toggle.attr('aria-expanded', 'false');
            nav.find('.main-nav').attr('aria-hidden', 'true');
            toggle[0].focus();
        } else {
            nav.addClass('active');
            toggle.addClass('active');
            toggle.attr('aria-expanded', 'true');
            nav.find('.main-nav').attr('aria-hidden', 'false');

            const firstFocusable = nav[0].querySelector('a, button, [tabindex]');
            if (firstFocusable) {
                firstFocusable.focus();
            }
        }
    });

    $('.search-trigger').on('click', function (e) {
        e.preventDefault();
        const searchDrop = $('.search-dropdown');
        const trigger = $(this);

        if (searchDrop.hasClass('active')) {
            searchDrop.removeClass('active');
            searchDrop.attr('aria-hidden', 'true');
            trigger.attr('aria-expanded', 'false');
        } else {
            searchDrop.addClass('active');
            searchDrop.attr('aria-hidden', 'false');
            trigger.attr('aria-expanded', 'true');

            const searchInput = searchDrop[0].querySelector('input[type="search"]');
            if (searchInput) {
                searchInput.focus();
            }
        }
    });

    $('.search-close').on('click', function (e) {
        e.preventDefault();
        const searchDrop = $('.search-dropdown');

        if (searchDrop.hasClass('active')) {
            searchDrop.removeClass('active');
            searchDrop.attr('aria-hidden', 'true');
            $('.search-trigger').attr('aria-expanded', 'false');
        }
    });

    $('.menu-item.has-children a').on('click', function (e) {
        var el = $(this);
        var parent = el.parent();

        if (windowWidth < 992 && !parent.hasClass('active')) {
            e.preventDefault();
            $('.menu-item .has-children').removeClass('active');
            parent.addClass('active');
        }
    });
};

$(initFrontendChrome);
